/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutConsentDefault = typeof OrgSettingsPutConsentDefault[keyof typeof OrgSettingsPutConsentDefault] | null;


export const OrgSettingsPutConsentDefault = {
  opt_out: 'opt_out',
  opt_in: 'opt_in',
} as const;
